import { render, staticRenderFns } from "./BGamingFreespinsAddForm.vue?vue&type=template&id=bbcd8a28&"
import script from "./BGamingFreespinsAddForm.vue?vue&type=script&lang=js&"
export * from "./BGamingFreespinsAddForm.vue?vue&type=script&lang=js&"
import style0 from "./BGamingFreespinsAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports